<span  class="{{className}}" data-bs-toggle="tooltip" ngbTooltip="{{toolTip}}" placement="{{placement}}"  (click)="onClickEvent($event)">
  @if (!loadingIcon && iconSrc) {
    <img src="{{iconSrc}}" alt=""/>
  }
  @if (!loadingIcon && faIcon) {
    <span >
      <fa-icon [icon]="faIcon"></fa-icon>
    </span>
  }
  @if (!loadingIcon && text) {
    <span>
      {{text}}
    </span>
  }
  @if (loadingIcon && progress !== undefined) {
    <div class="circular-loader">
      <svg viewBox="0 0 36 36" class="circular-chart">
        <path class="circle-bg" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
        <path class="circle" [attr.stroke-dasharray]="progress + ', 100'" d="M18 2.0845
               a 15.9155 15.9155 0 0 1 0 31.831
               a 15.9155 15.9155 0 0 1 0 -31.831" />
          </svg>
          <span class="percentage-text">{{ progress }}%</span>
        </div>
      }
      @if (loadingIcon && progress === undefined) {
        <fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>
      }
    </span>
